import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { logout } from '../utils/auth';
import { toast, ToastContainer, Slide } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
import { FaUsersRectangle } from 'react-icons/fa6';
import { HiOutlinePencilSquare } from 'react-icons/hi2';
import { FaMobileScreenButton } from 'react-icons/fa6';
import { PiListBulletsFill } from 'react-icons/pi';
import { MdVerified, MdHistory } from 'react-icons/md';
import { CiSearch } from 'react-icons/ci';
import { MdRefresh } from 'react-icons/md';
import { loadStripe } from '@stripe/stripe-js';
import { useMemo } from 'react';
import { getAppType } from '../utils/appConstants';

import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { handleLogout } from '../utils/api';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-number-input/style.css';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/manual-reg.css';
import '../styles/renewals.css';
import { FaGalacticSenate } from 'react-icons/fa';

const Renewals = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const email = localStorage.getItem('userEmail'); // default if missing
  const userInitial = email.charAt(0).toUpperCase();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showManualPayment, setShowManualPayment] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('cash');

  const [managementReason, setManagementReason] = useState('');
  const firstName = localStorage.getItem('firstName');
  const lastName = localStorage.getItem('lastName');

  const appGroup = localStorage.getItem('appGroup');

  const userType = localStorage.getItem('userType') || 'admin';

  const [loading, setLoading] = useState(false);
  const [confirmVerify, setConfirmVerify] = useState({
    open: false,
    userId: null,
  });

  const [member, setMember] = useState(null);

  const [venues, setVenues] = useState([]);
  const [mobile, setMobile] = useState('');
  const [renewalData, setRenewalData] = useState([]);
  const [earlyBird, setEarlyBird] = useState(false);

  const token = localStorage.getItem('token');
  const [selectedVenue, setSelectedVenue] = useState(
    localStorage.getItem('selectedVenue') || ''
  );

  const isClubApp =
    selectedVenue === 'Qantum' ||
    selectedVenue === 'Ace' ||
    selectedVenue === 'Manly' ||
    selectedVenue === 'MaxGaming' ||
    selectedVenue === 'Mannum' ||
    selectedVenue === 'TeaGarden';

  const [userTimeZone, setUserTimeZone] = useState('');

  const [id, setId] = useState('');

  // s1 = Register New Member, s2 = Set Membership Level, s3 = Payment Details
  const [s1Visible, setS1Visible] = useState(true); // only s1 shown at start
  const [s2Visible, setS2Visible] = useState(false);
  const [s3Visible, setS3Visible] = useState(false);

  // editing controls: when true -> show Cancel + Next; when false -> show Edit
  // requirement: at beginning register new member should show Cancel + Next
  const [editing1, setEditing1] = useState(true);
  const [editing2, setEditing2] = useState(false);

  const [formData, setFormData] = useState({
    Id: '',
    GivenNames: '',
    Surname: '',
    Email: '',
    Mobile: '',
    // mobileFull: '',
    Address: '',
    Suburb: '',
    PostCode: '',
    DateOfBirth: '',
    Gender: '',
    membershipLevel: '',
    paymentEmail: '',
    cardNumber: '',
    expiryDate: '',
    cvv: '',
    nameOnCard: '',
    country: 'Australia',
    region: null,
  });

  const [clientSecret, setClientSecret] = useState(null);
  const [showStripe, setShowStripe] = useState(false);
  const [verifyPayload, setVerifyPayload] = useState(null);
  const [showConfirmMembership, setShowConfirmMembership] = useState(false);
  const [fromMakePayment, setFromMakePayment] = useState(false);

  const [searchParams] = useSearchParams();
  const user_id = searchParams.get('user_id');
  const appType = searchParams.get('appType');
  const isEditMode = searchParams.get('mode') === 'edit';

  const member_search_mobile = searchParams.get('member_search_mobile');
  const member_search_appType = searchParams.get('member_search_appType');
  const [loadingRenewal, setLoadingRenewal] = useState(false);
  console.log('member_search_mobile:', member_search_mobile);
  console.log('member_search_appType:', member_search_appType);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value;

    // Email: allow letters, numbers, @ . _ -
    if (name === 'Email' || name === 'paymentEmail') {
      sanitizedValue = value.replace(/[^a-zA-Z0-9@._-]/g, '');
    }

    // Address: allow letters (all languages), numbers, space, comma and '/'
    else if (name === 'Address') {
      sanitizedValue = value.replace(/[^\p{L}\p{M}0-9\s,\/]/gu, '');
    }

    // Names, Suburb, Region: letters (all languages) + space only
    else if (
      name === 'GivenNames' ||
      name === 'Surname' ||
      name === 'Suburb' ||
      name === 'region' ||
      name === 'nameOnCard'
    ) {
      sanitizedValue = value.replace(/[^\p{L}\p{M}\s]/gu, '');
    }

    // PostCode: numbers only
    else if (name === 'PostCode') {
      sanitizedValue = value.replace(/[^0-9]/g, '');
    }

    // Mobile: numbers only
    else if (name === 'Mobile') {
      sanitizedValue = value.replace(/[^0-9]/g, '');
    }

    setFormData((prev) => ({
      ...prev,
      [name]: sanitizedValue,
    }));
  };

  const [membershipPackages, setMembershipPackages] = useState([]);
  const storedRaw = localStorage.getItem('manualRegUserData');
  const stored = storedRaw ? JSON.parse(storedRaw) : null;

  const stripePromise = useMemo(() => {
    return loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY, {
      stripeAccount:
        selectedVenue === 'MaxGaming'
          ? process.env.REACT_APP_STRIPE_ACCOUNT_ID_MAX
          : selectedVenue === 'Mannum'
            ? process.env.REACT_APP_STRIPE_ACCOUNT_ID_MANNUM
            : process.env.REACT_APP_STRIPE_ACCOUNT_ID,
    });
  }, [selectedVenue]);

  useEffect(() => {
    const fetchVenues = async () => {
      try {
        const response = await axios.get(`${baseUrl}/admin/app-registries`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data && response.data.data) {
          setVenues(response.data.data);
          //   setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching venues:', error);
        // setLoading(false);
      }
    };

    if (token && userType === 'admin') {
      fetchVenues();
    }
  }, [token]);

  const handleVenueChange = async (e) => {
    const newVenue = e.target.value;
    if (!newVenue) return;

    try {
      const response = await axios.post(
        `${baseUrl}/admin/token`,
        {
          appType: newVenue,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data?.data?.token) {
        // Save the new token
        const newToken = response.data.data.token;
        localStorage.removeItem('token');
        localStorage.setItem('token', newToken);

        // Update the selected venue after successful token update
        setSelectedVenue(newVenue);
        localStorage.removeItem('selectedVenue');
        localStorage.setItem('selectedVenue', newVenue);

        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Error updating token:', error);
      toast.error('Failed to update venue');
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // const handleLock = async () => {
  //   try {
  //     const result = await handleLogout();
  //     if (result.success) {
  //       navigate('/dashboard');
  //     } else {
  //       toast.error(
  //         result.message || 'Failed to remove lock. Please try again.'
  //       );
  //     }
  //   } catch (error) {
  //     console.error('Error in handleLock:', error);
  //     toast.error(error.message || 'Failed to remove lock. Please try again.');
  //   }
  // };

  const fetchRenewal = async () => {
    let url = `${baseUrl}/user/renew-details/${mobile}?appType=${selectedVenue}`;
    {
      member_search_mobile &&
        member_search_appType &&
        (url = `${baseUrl}/user/renew-details/${member_search_mobile}?appType=${member_search_appType}`);
    }
    setLoadingRenewal(true);
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.data && response.data?.mobile?.user?._id) {
        setId(response.data?.mobile?.user?._id);
      }

      if (response.data && !response.data.mobile.registered) {
        setMember('new');
      } else {
        if (
          response.data.mobile.earlyBird === true ||
          response.data.mobile.earlyBird === 'true'
        ) {
          setEarlyBird(true);
        }
        const expiry = new Date(response.data.mobile.user.ExpiryDate);
        const now = new Date();
        if (expiry >= now) {
          setMember('financial');
        } else {
          setMember('renewal');
        }
        setRenewalData(response.data.mobile.user);
      }
    } catch (err) {
      console.error('Error fetching renewal:', err);
    } finally {
      setLoadingRenewal(false);
    }
  };

  useEffect(() => {
    if (member_search_mobile && member_search_appType) {
      fetchRenewal();
    }
  }, [member_search_mobile, member_search_appType]);

  useEffect(() => {
    console.log('member updated:', member);
  }, [member]);

  const resetManualReg = () => {
    // Remove stored data
    localStorage.removeItem('manualRegUserData');

    // Reset all local states
    setRenewalData([]);
    setFromMakePayment(false);
    setShowStripe(false);
    setClientSecret(null);
    setVerifyPayload(null);
    setShowConfirmMembership(false);
    setShowManualPayment(false);

    setManagementReason('');

    // Reset section visibility
    setS1Visible(true);
    setS2Visible(false);
    setS3Visible(false);

    // Reset editing mode
    setEditing1(true);
    setEditing2(false);

    // Reset formData
    setFormData({
      GivenNames: '',
      Surname: '',
      Email: '',
      Mobile: '',
      Address: '',
      Suburb: '',
      PostCode: '',
      DateOfBirth: '',
      Gender: '',
      membershipLevel: '',
      paymentEmail: '',
      cardNumber: '',
      expiryDate: '',
      cvv: '',
      nameOnCard: '',
      country: 'Australia',
      region: null,
    });
  };

  const handleManualPaymentClick = () => {
    setShowManualPayment(true);
  };

  const handleCancelManualPayment = () => {
    setShowManualPayment(false);
    setManagementReason('');
  };

  const handleConfirmManualPayment = async () => {
    if (selectedPaymentMethod === 'management' && !managementReason.trim()) {
      toast.error('Please enter a reason for Management approved payment');
      return;
    }

    const selectedPkg = membershipPackages.find(
      (pkg) => pkg._id === formData.membershipLevel
    );

    const payload = {
      GivenNames: formData.GivenNames,
      Surname: formData.Surname,
      DateOfBirth: formData.DateOfBirth,
      PostCode: formData.PostCode,
      Email: formData.Email,
      Gender: formData.Gender,
      Address: formData.Address,
      Mobile: formData.Mobile,
      Suburb: formData.Suburb,
      State: null,
      amountPaid:
        earlyBird === true
          ? selectedPkg?.price * 100 || 0
          : selectedPkg?.calculatedPrice * 100 || 0,
      currency: 'aud',
      paymentType: selectedPaymentMethod,
      ...(selectedPaymentMethod === 'management' && {
        managementReason: managementReason.trim(),
        management_Approver: `${firstName || ''} ${lastName || ''}`.trim(),
      }),
      packageId: selectedPkg?._id,
      packageName: selectedPkg?.membershipName,
      ...(member === 'renewal' && { renewType: 'renew' }),
    };

    // {
    //   selectedVenue === 'Manly' && (payload.type = 'new');
    // }

    if (member === 'renewal' || earlyBird === true) {
      try {
        let url = `${baseUrl}/user/${id}/renewal/manual?appType=${selectedVenue}`;
        if (earlyBird) {
          url = `${baseUrl}/user/${id}/earlyBird-manual?appType=${selectedVenue}`;
        }
        const res = await axios.put(
          url,
          payload
          // {
          //   headers: { Authorization: `Bearer ${token}` },
          // }
        );

        if (
          res?.data?.success ||
          res?.data?.message === 'User updated successfully .' ||
          res?.data?.message ===
            'User updated successfully (Reception). Email sent.'
        ) {
          toast.success('Payment successful');
          setShowManualPayment(false);
          // optionally close payment section:
          // setS3Visible(false);
          // updateS2W(stored.Id);
          setTimeout(() => navigate('/approvals'), 2000);
          setTimeout(() => resetManualReg(), 4000);
        } else {
          toast.error('Payment failed or cancelled');
          // resetManualReg();
        }

        return;
      } catch (err) {
        console.error(err);
        toast.error('Failed to update payment');
        // resetManualReg();
        return;
      }
    }
    // try {
    //   const res = await axios.post(
    //     selectedVenue === 'Manly'
    //       ? `${baseUrl}/user/user-reception-register-mhbc?appType=${selectedVenue}`
    //       : `${baseUrl}/user/user-reception-register?appType=${selectedVenue}`,
    //     payload,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );

    //   if (res?.data?.thirdPartyData?.Id) {
    //     toast.success('Payment successful');
    //     setShowManualPayment(false);
    //     // updateS2W(res?.data?.thirdPartyData?.Id);
    //     setTimeout(() => navigate('/approvals'), 2000);
    //     setTimeout(() => resetManualReg(), 4000);
    //     // optionally close payment section:
    //     // setS3Visible(false);
    //   } else {
    //     toast.error('Payment failed or cancelled');
    //     resetManualReg();
    //   }
    // } catch (error) {
    //   console.error(error);
    //   toast.error('Payment failed or cancelled');
    //   resetManualReg();
    // }
  };

  // const handleLock = async () => {
  //   try {
  //     resetManualReg();
  //     const result = await handleLogout();
  //     if (result.success) {
  //       navigate('/dashboard');
  //     } else {
  //       toast.error(
  //         result.message || 'Failed to remove lock. Please try again.'
  //       );
  //     }
  //   } catch (error) {
  //     console.error('Error in handleLock:', error);
  //     toast.error(error.message || 'Failed to remove lock. Please try again.');
  //   }
  // };

  const handleNextS1 = async () => {
    // Step forward from Register -> Membership Level

    if (member === 'renewal' || earlyBird) {
      setS2Visible(true);
      setEditing1(false);
      setEditing2(true);
      return;
    }

    if (
      !formData.GivenNames ||
      !formData.Surname ||
      !formData.Address ||
      !formData.Suburb ||
      !formData.PostCode ||
      !formData.DateOfBirth ||
      !formData.Gender
    ) {
      toast.error('Please fill all required fields');
      return;
    }

    if (!formData.Mobile || !formData.Email || formData.Mobile.length < 10) {
      toast.error('Please enter valid mobile number and email');
      return;
    }

    try {
      const body = {
        Mobile: formData.Mobile,
        Email: formData.Email,
      };

      const res = await axios.post(
        `${baseUrl}/user/check-user?appType=${selectedVenue}`,
        body,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const mobileReg = res.data?.mobile?.registered;
      const emailReg = res.data?.email?.registered;

      // CASE: both registered
      if (mobileReg && emailReg) {
        toast.error('Mobile number and Email are already registered');
        return;
      }

      // CASE: mobile registered
      if (mobileReg) {
        toast.error('Mobile number is already registered');
        return;
      }

      // CASE: email registered
      if (emailReg) {
        toast.error('Email is already registered');
        return;
      }

      // BOTH FALSE → proceed to section 2
      setS2Visible(true);
      setEditing1(false);
      setEditing2(true);
    } catch (err) {
      console.error(err);
      toast.error('Failed to validate user');
    }
  };

  const handleCancelS1 = () => {
    // Spec: clicking Cancel on section 1 should do nothing
    // no-op intentionally
  };

  const handleEditS1 = () => {
    // If edit clicked on s1: hide other sections & show cancel+next on s1
    setS2Visible(false);
    setS3Visible(false);
    setEditing1(true);
    setEditing2(false);
  };

  const handleNextS2 = () => {
    // From membership -> payment
    if (!formData.membershipLevel) {
      toast.error('Please select a membership level.');
      return;
    }

    // show edit button immediately
    setEditing2(false);

    // Show confirmation box
    setShowConfirmMembership(true);
  };

  const handleCancelS2 = () => {
    setTimeout(() => navigate('/approvals'), 1000);
    setTimeout(() => resetManualReg(), 2000);
  };

  const handleEditS2 = () => {
    // If edit clicked on s2: hide payment & show cancel+next on s2
    setS3Visible(false);
    setEditing2(true);
  };

  useEffect(() => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setUserTimeZone(tz);
    localStorage.setItem('userTimeZone', tz); // optional
  }, []);

  useEffect(() => {
    const fetchMembershipPackages = async () => {
      if (!selectedVenue || !userTimeZone || !isClubApp) return;

      let url = `${baseUrl}/club-package/club?appType=${selectedVenue}&timezone=${encodeURIComponent(
        userTimeZone
      )}`;

      if (earlyBird) {
        url = `${baseUrl}/club-package/earlybird?appType=${selectedVenue}`;
        setMembershipPackages([]);
      }

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data?.data) {
          setMembershipPackages(response.data.data);
          // Set default membership level if not set
          // if (response.data.data.length > 0 && !formData.membershipLevel) {
          //   setFormData(prev => ({
          //     ...prev,
          //     membershipLevel: response.data.data[0]._id
          //   }));
          // }
        }
      } catch (error) {
        console.error('Error fetching membership packages:', error);
        toast.error('Failed to load membership packages');
      }
    };

    fetchMembershipPackages();
  }, [token, selectedVenue, userTimeZone, earlyBird]);

  const handlePay = async () => {
    const selectedPkg = membershipPackages.find(
      (pkg) => pkg._id === formData.membershipLevel
    );

    if (member === 'renewal' || earlyBird === true) {
      try {
        const body = {
          GivenNames: formData.GivenNames,
          Surname: formData.Surname,
          DateOfBirth: formData.DateOfBirth,
          PostCode: formData.PostCode,
          Email: formData.Email,
          Gender: formData.Gender,
          Address: formData.Address,
          Suburb: formData.Suburb,
          Mobile: formData.Mobile,
          State: null,
          amountPaid:
            earlyBird === true
              ? selectedPkg?.price * 100 || 0
              : selectedPkg?.calculatedPrice * 100 || 0,
          currency: 'aud',
          packageId: selectedPkg?._id,
          packageName: selectedPkg?.membershipName,
          paymentType: 'card',
          ...(member === 'renewal' && { renewType: 'renew' }),
        };

        let url = `${baseUrl}/user/${id}/renewal/payment?appType=${selectedVenue}`;

        if (earlyBird === true) {
          url = `${baseUrl}/user/${id}/earlyBird-payment?appType=${selectedVenue}`;
        }

        const res = await axios.put(
          url,
          body
          // {
          //   headers: { Authorization: `Bearer ${token}` },
          // }
        );

        const secret = res.data?.payment?.clientSecret;

        if (!secret) {
          toast.error('Could not initialize payment');
          return;
        }

        // Automatically show confirm box like Stripe success
        setShowStripe(true);
        setClientSecret(secret);
        setVerifyPayload({
          paymentIntentId: res.data?.payment?.paymentIntentId,
          userId: res.data?.userId,
          appType: selectedVenue,
          selectedPkg: selectedPkg,
        });

        return;
      } catch (err) {
        console.error(err);
        toast.error('Failed to update payment');
        return;
      }
    }
    // try {
    //   const payload = {
    //     GivenNames: formData.GivenNames,
    //     Surname: formData.Surname,
    //     DateOfBirth: formData.DateOfBirth,
    //     PostCode: formData.PostCode,
    //     Mobile: formData.Mobile,
    //     Email: formData.Email,
    //     Gender: formData.Gender,
    //     Address: formData.Address,
    //     Suburb: formData.Suburb,
    //     State: formData.region,
    //     amountPaid: selectedPkg?.calculatedPrice * 100 || 0,
    //     currency: 'aud',
    //     packageId: selectedPkg?._id,
    //     packageName: selectedPkg?.membershipName,
    //     paymentType: 'card',
    //   };
    //   {
    //     selectedVenue === 'Manly' && (payload.type = 'new');
    //   }

    //   // 1) Create user + paymentIntent via your backend
    //   const res = await axios.post(
    //     selectedVenue === 'Manly'
    //       ? `${baseUrl}/user/user-register-mhbc?appType=${selectedVenue}`
    //       : `${baseUrl}/user/user-register?appType=${selectedVenue}`,
    //     payload,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );

    //   const secret = res.data?.payment?.clientSecret;

    //   if (!secret) {
    //     toast.error('Could not initialize payment');
    //     return;
    //   }

    //   // store clientSecret and open Stripe card input
    //   setClientSecret(secret);
    //   setShowStripe(true);
    //   setVerifyPayload({
    //     paymentIntentId: res.data?.payment?.paymentIntentId,
    //     userId: res.data?.userId,
    //     appType: selectedVenue,
    //     selectedPkg: selectedPkg,
    //   });
    // } catch (err) {
    //   console.error(err);
    //   toast.error(
    //     `Registration failed - ${
    //       err.response?.data?.Message || err.response?.data
    //     }`
    //   );
    //   resetManualReg();
    // }
  };

  function CardPaymentUI({ clientSecret, onSuccess }) {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
      if (!stripe || !elements) {
        toast.error('Stripe is not loaded yet');
        return;
      }

      setLoading(true);

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: {
            name: formData.nameOnCard || undefined,
            email: formData.paymentEmail || undefined,
          },
        },
      });

      try {
        const verifyBody = {
          paymentIntentId: verifyPayload.paymentIntentId,
          userId: verifyPayload.userId,
          appType: verifyPayload.appType,
          packageId: verifyPayload.selectedPkg?._id,
          packageName: verifyPayload.selectedPkg?.membershipName,
          paymentType: 'card',
        };

        let url = `${baseUrl}/payment/verify-payment`;

        if (earlyBird === true) {
          url = `${baseUrl}/payment/verify-payment-early`;
        }

        await axios.post(url, verifyBody, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setLoading(false);

        if (result.error) {
          toast.error(result.error.message);
          // resetManualReg();
        } else if (
          result.paymentIntent &&
          result.paymentIntent.status === 'succeeded'
        ) {
          toast.success('Payment successful');

          setTimeout(() => navigate('/approvals'), 2000);
          setTimeout(() => resetManualReg(), 4000);
          // updateS2W(verifyPayload.userId);
        } else {
          toast.error('Payment failed or cancelled');
          // resetManualReg();
        }
      } catch (err) {
        setLoading(false);
        console.error(err);
        toast.error('Payment failed');
        // resetManualReg();
      }
    };

    return (
      <div style={{ marginTop: '20px' }}>
        {/* <CardElement
          options={{ hidePostalCode: true }}
          style={{ base: { fontSize: '16px' } }}
        /> */}
        <button
          onClick={handleConfirm}
          disabled={!stripe || !elements || loading}
          style={{
            marginTop: '20px',
            width: '100%',
            padding: '12px',
            backgroundColor: '#4a90e2',
            color: 'white',
            fontWeight: '600',
            borderRadius: '20px',
            cursor: 'pointer',
          }}
        >
          {loading ? 'Processing...' : 'Confirm Payment'}
        </button>
      </div>
    );
  }

  useEffect(() => {
    // Auto set paymentEmail from registration email
    setFormData((prev) => ({
      ...prev,
      paymentEmail: prev.Email,
    }));
  }, [formData.Email]);

  // Disable all inputs in a section when editing = false
  const disableIf = (condition) => ({
    disabled: !condition,
    style: !condition
      ? { backgroundColor: '#f2f2f2', cursor: 'not-allowed' }
      : {},
  });

  //   useEffect(() => {
  //     if (!stored) return;

  //     const u = stored;

  //     // --- REGISTER NEW MEMBER (Section 1) ---
  //     setFormData((prev) => ({
  //       ...prev,
  //       GivenNames: u.GivenNames || '',
  //       Surname: u.Surname || '',
  //       Email: u.Email || '',
  //       Mobile: u.Mobile || '',
  //       Address: u.Address || '',
  //       PostCode: u.PostCode || '',
  //       Suburb: u.Suburb || '',
  //       Gender: u.Gender || '',
  //       DateOfBirth: u.DateOfBirth ? u.DateOfBirth.substring(0, 10) : '',

  //       // --- SET MEMBERSHIP LEVEL (Section 2) ---
  //       membershipLevel: u.packageId || '',

  //       // --- PAYMENT DETAILS (Section 3) ---
  //       cardNumber: u.CardNumber || '',
  //       paymentEmail: u.Email || '',
  //       amountPaid: u.amountPaid || 0,

  //       // these fields keep current values unless Manual-Payment or card is used
  //       expiryDate: prev.expiryDate,
  //       cvv: prev.cvv,
  //       nameOnCard: prev.nameOnCard,
  //       country: prev.country,
  //       region: prev.region,
  //     }));

  //     setFromMakePayment(true);
  //   }, []);

  useEffect(() => {
    if (member !== 'renewal' && !earlyBird) return;

    // 1️⃣ Section 1 should be filled & locked (like after clicking Next)
    setEditing1(false); // remove Cancel/Next, show EDIT button
    setS1Visible(true);

    // 2️⃣ Section 2 should be visible with EDIT mode enabled
    setS2Visible(true);
    setEditing2(true);
  }, [member, earlyBird]);

  useEffect(() => {
    if (!isEditMode || !user_id || !appType) return;

    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `${baseUrl}/user/${user_id}?appType=${appType}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const u = res.data?.data;
        if (!u) {
          toast.error('User data not found');
          return;
        }

        setFormData((prev) => ({
          ...prev,
          Id: u.Id || '',
          GivenNames: u.GivenNames || '',
          Surname: u.Surname || '',
          Email: u.Email || '',
          Mobile: u.Mobile || '',
          Address: u.Address || '',
          Suburb: u.Suburb || '',
          PostCode: u.PostCode || '',
          Gender: u.Gender || '',
          DateOfBirth: u.DateOfBirth ? u.DateOfBirth.substring(0, 10) : '',
        }));

        // 🔒 Edit-only mode
        setS1Visible(true);
        setS2Visible(false);
        setS3Visible(false);
        setEditing1(true);
      } catch (err) {
        console.error(err);
        toast.error('Failed to load user details');
      }
    };

    fetchUser();
  }, [isEditMode, user_id, appType]);

  const handleSaveEdit = async () => {
    try {
      const payload = {
        Id: formData.Id,
        GivenNames: formData.GivenNames,
        Surname: formData.Surname,
        Email: formData.Email,
        Mobile: formData.Mobile,
        DateOfBirth: new Date(formData.DateOfBirth).toISOString(),
        Address: formData.Address,
        Suburb: formData.Suburb,
        PostCode: formData.PostCode,
        Gender: formData.Gender,
      };

      await axios.patch(`${baseUrl}/user/update-profile-s2w`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success('Profile updated successfully');
      setTimeout(() => navigate('/approvals'), 1500);
    } catch (err) {
      console.error(err);
      toast.error('Failed to update profile');
    }
  };

  useEffect(() => {
    if (member !== 'renewal' && !earlyBird) return;

    setFormData({
      GivenNames: renewalData.GivenNames || '',
      Surname: renewalData.Surname || '',
      Email: renewalData.Email || '',
      Mobile: renewalData.Mobile || '',
      Address: renewalData.Address || '',
      Suburb: renewalData.Suburb || '',
      PostCode: renewalData.PostCode || '',
      DateOfBirth: renewalData.DateOfBirth
        ? renewalData.DateOfBirth.substring(0, 10)
        : '',
      Gender: renewalData.Gender || '',
      membershipLevel: renewalData.membershipType || '',
      cardNumber: renewalData.CardNumber || '',
      expiryDate: renewalData.expiryDate
        ? renewalData.expiryDate.substring(0, 10).split('-').reverse().join('-')
        : '',
      cvv: '',
      nameOnCard: '',
      country: 'Australia',
      region: null,
    });
  }, [member, earlyBird, renewalData]);

  if (loadingRenewal) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '20px',
          marginTop: '80px',
          fontWeight: 'bold',
          fontSize: '30px',
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
        style={{
          zIndex: 9999,
          marginTop: '90px',
          fontSize: '14px',
          minWidth: '300px',
          textAlign: 'center',
        }}
      />
      {/* Header */}
      <header className="dashboard-header">
        <div className="s2w-logo" onClick={() => navigate('/dashboard')}>
          <img src="/s2w-logo.png" alt="S2W Logo" />
        </div>

        <div
          style={{
            position: 'relative',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {userType === 'admin' && (
            <>
              <p
                style={{
                  position: 'absolute',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  fontWeight: 'bold',
                  color: '#002977',
                  fontSize: '20px',
                  margin: 0,
                }}
              >
                Admin
              </p>
              <div
                style={{
                  position: 'absolute',
                  right: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <span
                  style={{
                    fontWeight: '500',
                    color: '#002977',
                    fontSize: '15px',
                    fontWeight: 'bold',
                  }}
                >
                  Venue
                </span>
                <select
                  style={{
                    padding: '5px 10px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    backgroundColor: '#F2F2F2',
                    cursor: 'pointer',
                    minWidth: '200px',
                  }}
                  className="form-select"
                  value={selectedVenue}
                  onChange={handleVenueChange}
                  // disabled={loading}
                  required
                >
                  {venues.map(
                    (venue) =>
                      venue.appType === appGroup &&
                      venue.appName &&
                      venue.appName.map((app, index) => (
                        <option key={`${venue._id}-${index}`} value={app}>
                          {getAppType(app)}
                        </option>
                      ))
                  )}
                </select>
              </div>
            </>
          )}
        </div>

        <div className="user-section">
          <div
            className="user-avatar"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {userInitial}
          </div>
          {showDropdown && (
            <div className="dropdown-menu">
              <p>{email}</p>
              <button className="logout-btn" onClick={() => logout(navigate)}>
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      {/* sidebar */}
      {isClubApp ? (
        <aside className="sidebar-sa">
          <button
            style={{ fontSize: '12px' }}
            className={`sidebar-btn ${isActive('/approvals') ? 'active' : ''}`}
            onClick={() => navigate('/approvals')}
          >
            <FaUsersRectangle
              className={`sidebar-icon ${
                isActive('/approvals') ? '' : 'navy-icon'
              }`}
            />{' '}
            &nbsp; Approvals
          </button>
          <button
            style={{ fontSize: '12px' }}
            className={`sidebar-btn ${isActive('/manual-reg') ? 'active' : ''}`}
            onClick={() => navigate('/manual-reg')}
          >
            <HiOutlinePencilSquare
              className={`sidebar-icon ${
                isActive('/manual-reg') ? '' : 'navy-icon'
              }`}
            />{' '}
            &nbsp; Manual Registration
          </button>
          <button
            style={{ fontSize: '12px' }}
            className={`sidebar-btn ${isActive('/club-pkg') ? 'active' : ''}`}
            onClick={() => navigate('/club-pkg')}
          >
            <PiListBulletsFill
              className={`sidebar-icon ${
                isActive('/club-pkg') ? '' : 'navy-icon'
              }`}
            />{' '}
            &nbsp; Club Package
          </button>

          {/* <button
                          style={{ fontSize: '12px' }}
                          className={`sidebar-btn ${isActive('/app-settings') ? 'active' : ''}`}
                          onClick={() => navigate('/app-settings')}
                        >
                          <FaMobileScreenButton
                            className={`sidebar-icon ${
                              isActive('/app-settings') ? '' : 'navy-icon'
                            }`}
                          />{' '}
                          &nbsp; App Settings
                        </button> */}

          <button
            style={{ fontSize: '12px' }}
            className={`sidebar-btn ${
              isActive('/payment-reporting') ? 'active' : ''
            }`}
            onClick={() => navigate('/payment-reporting')}
          >
            <MdVerified
              className={`sidebar-icon ${
                isActive('/payment-reporting') ? '' : 'navy-icon'
              }`}
            />{' '}
            &nbsp; Payment Reporting
          </button>

          <button
            style={{ fontSize: '12px' }}
            className={`sidebar-btn ${isActive('/renewals') ? 'active' : ''}`}
            onClick={() => navigate('/renewals')}
          >
            <MdRefresh
              className={`sidebar-icon ${
                isActive('/renewals') ? '' : 'navy-icon'
              }`}
            />{' '}
            &nbsp; Renewals
          </button>

          <button
            style={{ fontSize: '12px' }}
            className={`sidebar-btn ${isActive('/member-search') ? 'active' : ''}`}
            onClick={() => navigate('/member-search')}
          >
            <CiSearch
              className={`sidebar-icon ${
                isActive('/member-search') 
                  ? ''
                  : 'navy-icon'
              }`}
            />{' '}
            &nbsp; Member Search
          </button>

          <button
            style={{ fontSize: '12px' }}
            className={`sidebar-btn ${isActive('/transaction-history') ? 'active' : ''}`}
            onClick={() => navigate('/transaction-history')}
          >
            <MdHistory
              className={`sidebar-icon ${
                isActive('/transaction-history') ? '' : 'navy-icon'
              }`}
            />{' '}
            &nbsp; Transaction History
          </button>
        </aside>
      ) : (
        <aside className="sidebar-sa">
          <button
            style={{ fontSize: '12px' }}
            className={`sidebar-btn ${isActive('/member-search') || member_search_mobile || member_search_appType ? 'active' : ''}`}
            onClick={() => navigate('/member-search')}
          >
            <CiSearch
              className={`sidebar-icon ${
                isActive('/member-search') ||
                member_search_mobile ||
                member_search_appType
                  ? ''
                  : 'navy-icon'
              }`}
            />{' '}
            &nbsp; Member Search
          </button>

          <button
            style={{ fontSize: '12px' }}
            className={`sidebar-btn ${isActive('/transaction-history') ? 'active' : ''}`}
            onClick={() => navigate('/transaction-history')}
          >
            <MdHistory
              className={`sidebar-icon ${
                isActive('/transaction-history') ? '' : 'navy-icon'
              }`}
            />{' '}
            &nbsp; Transaction History
          </button>
        </aside>
      )}

      {member !== 'renewal' && !earlyBird && (
        <main className="main-content-renewals">
          <div className="renewal-center">
            <div className="renewal-box">
              <h3>Enter Phone Number</h3>
              <div className="input-row">
                <input
                  type="text"
                  className="mobile-input"
                  value={!member_search_mobile ? mobile : member_search_mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder="0412 345 678"
                />
                <button
                  className="go-btn"
                  onClick={() => {
                    fetchRenewal();
                  }}
                >
                  Go
                </button>
              </div>
              {member === 'new' && (
                <p className="sub-text">
                  Member does not exist please have member sign up as new
                  member.
                </p>
              )}
              {member === 'financial' && !earlyBird && (
                <p className="sub-text">
                  Member is already a financial member. <br />
                  Please have member install Loyalty App or print member card
                  from loyalty console.
                </p>
              )}
            </div>
          </div>
        </main>
      )}

      {(member === 'renewal' || earlyBird) && (
        <div className="content-wrapper-sa" style={{ top: '120px' }}>
          <section className="new-user-sa" style={{ height: '600px' }}>
            <h2>Register New Member</h2>
            <div className="form-group">
              <label style={{ fontWeight: 'bold' }}>First name</label>
              <input
                type="text"
                name="GivenNames"
                value={formData.GivenNames}
                onChange={handleInputChange}
                {...disableIf(editing1)}
              />
            </div>

            <div className="form-group">
              <label style={{ fontWeight: 'bold' }}>Last name</label>
              <input
                type="text"
                name="Surname"
                value={formData.Surname}
                onChange={handleInputChange}
                {...disableIf(editing1)}
              />
            </div>

            <div className="form-group">
              <label style={{ fontWeight: 'bold' }}>Phone</label>
              <input
                type="number"
                name="Mobile"
                value={formData.Mobile}
                onChange={handleInputChange}
                {...disableIf(editing1)}
              />
            </div>

            <div className="form-group">
              <label style={{ fontWeight: 'bold' }}>Email</label>
              <input
                type="email"
                name="Email"
                value={formData.Email}
                onChange={handleInputChange}
                {...disableIf(editing1)}
              />
            </div>

            <div className="form-group">
              <label style={{ fontWeight: 'bold', marginBottom: '50px' }}>
                Address
              </label>
              <div className="address-grid">
                <div className="address-row">
                  <input
                    type="text"
                    placeholder="Street Address"
                    name="Address"
                    value={formData.Address || ''}
                    onChange={handleInputChange}
                    {...disableIf(editing1)}
                  />
                </div>
                <div className="city-zip">
                  <input
                    type="text"
                    placeholder="City"
                    name="Suburb"
                    value={formData.Suburb || ''}
                    onChange={handleInputChange}
                    {...disableIf(editing1)}
                  />
                  <input
                    type="text"
                    placeholder="Postcode"
                    name="PostCode"
                    value={formData.PostCode || ''}
                    onChange={handleInputChange}
                    {...disableIf(editing1)}
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label style={{ fontWeight: 'bold' }}>Birthday</label>
              <input
                type="date"
                name="DateOfBirth"
                value={formData.DateOfBirth}
                onChange={handleInputChange}
                style={{ padding: '8px' }}
                {...disableIf(editing1)}
              />
            </div>

            <div className="form-group">
              <div
                style={{
                  display: 'flex',
                  gap: '5px',
                  whiteSpace: 'nowrap',
                }}
              >
                <label style={{ fontWeight: 'bold', minWidth: '62px' }}>
                  Gender
                </label>
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px',
                    marginLeft: '28px',
                  }}
                >
                  <input
                    type="radio"
                    name="Gender"
                    value="M"
                    checked={formData.Gender === 'M'}
                    onChange={handleInputChange}
                    style={{ accentColor: '#002977' }}
                    {...disableIf(editing1)}
                  />
                  Male
                </label>
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px',
                  }}
                >
                  <input
                    type="radio"
                    name="Gender"
                    value="F"
                    checked={formData.Gender === 'F'}
                    onChange={handleInputChange}
                    style={{ accentColor: '#002977' }}
                    {...disableIf(editing1)}
                  />
                  Female
                </label>

                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px',
                  }}
                >
                  <input
                    type="radio"
                    name="Gender"
                    value="U"
                    checked={formData.Gender === 'U'}
                    onChange={handleInputChange}
                    style={{ accentColor: '#002977' }}
                    {...disableIf(editing1)}
                  />
                  Non-binary
                </label>
              </div>
            </div>
            <div
              className="d-flex w-100 justify-content-center"
              style={{ marginTop: '120px' }}
            >
              {!isEditMode ? (
                <>
                  {editing1 ? (
                    <>
                      <button
                        className="cancel-btn cancel-s1"
                        onClick={handleCancelS1}
                      >
                        Cancel
                      </button>
                      <button className="next-btn" onClick={handleNextS1}>
                        Next
                      </button>
                    </>
                  ) : (
                    <button className="blue-btn" onClick={handleEditS1}>
                      EDIT
                    </button>
                  )}
                </>
              ) : (
                <button className="blue-btn" onClick={handleSaveEdit}>
                  Save
                </button>
              )}
            </div>
          </section>

          {s2Visible && (
            <section className="new-user-sa" style={{ height: '600px' }}>
              <h2>Set Membership Level</h2>
              <div className="form-group">
                <select
                  name="membershipLevel"
                  value={formData.membershipLevel || ''}
                  onChange={handleInputChange}
                  className="membershipLevel"
                  {...disableIf(editing2)}
                  style={{
                    width: '100%',
                    padding: '10px 15px',
                    border: 'none',
                    borderRadius: '6px',
                    backgroundColor: 'white',
                    appearance: 'none',
                    backgroundImage:
                      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23007bff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 15px center',
                    fontSize: '14px',
                    cursor: 'pointer',
                  }}
                >
                  {!formData.membershipLevel && (
                    <option value="" disabled style={{ display: 'none' }}>
                      Select from list
                    </option>
                  )}

                  {membershipPackages.map((pkg) => (
                    <option key={pkg._id} value={pkg._id}>
                      {pkg.membershipName}
                    </option>
                  ))}
                </select>
              </div>

              {showConfirmMembership && (
                <div
                  style={{
                    width: '86%',
                    background: 'white',
                    padding: '25px',
                    borderRadius: '10px',
                    marginTop: '158px',
                    marginLeft: '25px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    textAlign: 'center',
                  }}
                >
                  <p
                    style={{
                      fontSize: '15px',
                      marginBottom: '25px',
                      color: '#555',
                      lineHeight: '20px',
                    }}
                  >
                    Have you sighted the person’s
                    <br />
                    identification and checked it is valid
                    <br />
                    and they’re over 18?
                  </p>

                  <div
                    style={{
                      display: 'flex',
                      gap: '20px',
                      justifyContent: 'center',
                    }}
                  >
                    <button
                      onClick={() => {
                        // user clicked cancel
                        setShowConfirmMembership(false);
                        setEditing2(true); // restore Cancel + Next buttons
                      }}
                      style={{
                        padding: '10px 35px',
                        backgroundColor: '#D3D3D3',
                        color: '#555',
                        border: 'none',
                        borderRadius: '20px',
                        fontSize: '15px',
                        cursor: 'pointer',
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      onClick={() => {
                        // user clicked yes → open payment
                        setShowConfirmMembership(false);
                        setS3Visible(true);
                      }}
                      style={{
                        padding: '10px 35px',
                        backgroundColor: '#4A90E2',
                        color: 'white',
                        border: 'none',
                        borderRadius: '20px',
                        fontSize: '15px',
                        cursor: 'pointer',
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              )}

              <div
                className="d-flex w-100 justify-content-center"
                style={{
                  marginTop: !showConfirmMembership ? '420px' : '75px',
                }}
              >
                {editing2 ? (
                  <>
                    <button className="cancel-btn" onClick={handleCancelS2}>
                      Cancel
                    </button>
                    <button className="next-btn" onClick={handleNextS2}>
                      Next
                    </button>
                  </>
                ) : (
                  <button className="blue-btn" onClick={handleEditS2}>
                    EDIT
                  </button>
                )}
              </div>
            </section>
          )}

          {s3Visible && (
            <Elements stripe={stripePromise}>
              <section className="connected-sa" style={{ height: '600px' }}>
                {!showManualPayment ? (
                  <>
                    <h2>Payment Details</h2>
                    <div className="payment-white-box">
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: 'bold',
                            fontSize: '13px',
                            color: '#5a5a5a',
                          }}
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          name="paymentEmail"
                          value={formData.paymentEmail}
                          disabled
                          onChange={handleInputChange}
                          placeholder="ella.williams@example.com"
                          style={{
                            width: '100%',
                            // padding: '10px',
                            border: '1px solid #e0e0e0',
                            borderRadius: '6px',
                            fontSize: '14px',
                            marginTop: '5px',
                          }}
                        />
                      </div>

                      <div className="form-group" style={{ marginTop: '10px' }}>
                        <label
                          style={{
                            fontWeight: 'bold',
                            fontSize: '13px',
                            color: '#5a5a5a',
                          }}
                        >
                          Card information
                        </label>
                        {/* Stripe CardElement replaces Card Number + Expiry + CVC */}
                        <div
                          style={{
                            border: '1px solid #e0e0e0',
                            padding: '12px',
                            borderRadius: '6px',
                            background: 'white',
                            marginTop: '8px',
                          }}
                        >
                          <CardElement options={{ hidePostalCode: true }} />
                        </div>
                      </div>

                      <div className="form-group" style={{ marginTop: '10px' }}>
                        <label
                          style={{
                            fontWeight: 'bold',
                            fontSize: '13px',
                            color: '#5a5a5a',
                          }}
                        >
                          Name on card
                        </label>
                        <input
                          type="text"
                          name="nameOnCard"
                          value={formData.nameOnCard}
                          onChange={handleInputChange}
                          placeholder="Ella Williams"
                          style={{
                            width: '100%',
                            // padding: '10px',
                            border: '1px solid #e0e0e0',
                            borderRadius: '6px',
                            fontSize: '14px',
                            marginTop: '5px',
                          }}
                        />
                      </div>

                      <div className="form-group" style={{ marginTop: '10px' }}>
                        <label
                          style={{
                            fontWeight: 'bold',
                            fontSize: '13px',
                            color: '#5a5a5a',
                          }}
                        >
                          Country or region
                        </label>
                        <select
                          name="country"
                          value={formData.country}
                          onChange={handleInputChange}
                          style={{
                            width: '100%',
                            padding: '5px',
                            border: '1px solid #e0e0e0',
                            borderRadius: '6px',
                            fontSize: '14px',
                            marginTop: '5px',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                          }}
                        >
                          <option value="Australia">Australia</option>
                          <option value="United States">United States</option>
                          <option value="Canada">Canada</option>
                          <option value="United Kingdom">United Kingdom</option>
                        </select>
                        <input
                          type="text"
                          name="region"
                          value={formData.region}
                          onChange={handleInputChange}
                          placeholder="Queensland"
                          style={{
                            width: '100%',
                            // padding: '10px',
                            border: '1px solid #e0e0e0',
                            borderRadius: '6px',
                            fontSize: '14px',
                            marginTop: '10px',
                          }}
                        />
                      </div>

                      <button
                        onClick={handlePay}
                        style={{
                          width: '100%',
                          padding: '10px',
                          backgroundColor: '#5296D1',
                          color: 'white',
                          border: 'none',
                          borderRadius: '20px',
                          fontSize: '15px',
                          fontWeight: '600',
                          marginTop: '10px',
                          cursor: 'pointer',
                        }}
                      >
                        Pay AUD$
                        {earlyBird
                          ? membershipPackages
                              .find(
                                (pkg) => pkg._id === formData.membershipLevel
                              )
                              ?.price?.toFixed(2) || '0.00'
                          : membershipPackages
                              .find(
                                (pkg) => pkg._id === formData.membershipLevel
                              )
                              ?.calculatedPrice?.toFixed(2) || '0.00'}
                      </button>

                      {showStripe && clientSecret && (
                        <CardPaymentUI
                          clientSecret={clientSecret}
                          onSuccess={() => {
                            setShowStripe(false);
                            setClientSecret(null);
                          }}
                          verifyPayload={verifyPayload}
                        />
                      )}
                    </div>

                    <div
                      className="d-flex w-100 justify-content-center"
                      style={{ marginTop: '28px' }}
                    >
                      <button
                        className="payment-btn"
                        onClick={handleManualPaymentClick}
                      >
                        Select other payment method
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <h2>Manual Payment Details</h2>
                    <div style={{ marginTop: '30px' }}>
                      <p
                        style={{
                          fontSize: '14px',
                          color: '#5a5a5a',
                          marginBottom: '15px',
                        }}
                      >
                        Choose payment method
                      </p>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '12px',
                        }}
                      >
                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px',
                            cursor: 'pointer',
                          }}
                        >
                          <input
                            type="radio"
                            name="paymentMethod"
                            value="cash"
                            checked={selectedPaymentMethod === 'cash'}
                            onChange={(e) =>
                              setSelectedPaymentMethod(e.target.value)
                            }
                            style={{
                              width: '16px',
                              height: '16px',
                              cursor: 'pointer',
                              accentColor: '#002977',
                            }}
                          />
                          Cash
                        </label>
                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px',
                            cursor: 'pointer',
                          }}
                        >
                          <input
                            type="radio"
                            name="paymentMethod"
                            value="card_by_venue"
                            checked={selectedPaymentMethod === 'card_by_venue'}
                            onChange={(e) =>
                              setSelectedPaymentMethod(e.target.value)
                            }
                            style={{
                              width: '16px',
                              height: '16px',
                              cursor: 'pointer',
                              accentColor: '#002977',
                            }}
                          />
                          Venue EFT POS
                        </label>
                        {/* <label
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '8px',
                                          fontSize: '14px',
                                          cursor: 'pointer',
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="paymentMethod"
                                          value="cheque"
                                          checked={selectedPaymentMethod === 'cheque'}
                                          onChange={(e) =>
                                            setSelectedPaymentMethod(e.target.value)
                                          }
                                          style={{
                                            width: '16px',
                                            height: '16px',
                                            cursor: 'pointer',
                                            accentColor: '#002977',
                                          }}
                                        />
                                        Cheque
                                      </label> */}
                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px',
                            cursor: 'pointer',
                          }}
                        >
                          <input
                            type="radio"
                            name="paymentMethod"
                            value="management"
                            checked={selectedPaymentMethod === 'management'}
                            onChange={(e) =>
                              setSelectedPaymentMethod(e.target.value)
                            }
                            style={{
                              width: '16px',
                              height: '16px',
                              cursor: 'pointer',
                              accentColor: '#002977',
                            }}
                          />
                          Management approved
                        </label>

                        {selectedPaymentMethod === 'management' && (
                          <textarea
                            value={managementReason}
                            onChange={(e) =>
                              setManagementReason(e.target.value)
                            }
                            placeholder="You must enter a reason..."
                            required
                            rows={3}
                            style={{
                              width: '100%',
                              padding: '10px',
                              border: '1px solid #ddd',
                              borderRadius: '4px',
                              boxSizing: 'border-box',
                              resize: 'vertical',
                              fontSize: '12px',
                              marginTop: '20px',
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '15px',
                        marginTop:
                          selectedPaymentMethod !== 'management'
                            ? '347px'
                            : '250px',
                        justifyContent: 'center',
                      }}
                    >
                      <button
                        onClick={handleCancelManualPayment}
                        style={{
                          padding: '12px 40px',
                          backgroundColor: '#d3d3d3',
                          color: '#666',
                          border: 'none',
                          borderRadius: '25px',
                          fontSize: '15px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          minWidth: '120px',
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleConfirmManualPayment}
                        disabled={
                          selectedPaymentMethod === 'management' &&
                          !managementReason.trim()
                        }
                        style={{
                          padding: '12px 40px',
                          backgroundColor: '#4a90e2',
                          color: 'white',
                          border: 'none',
                          borderRadius: '25px',
                          fontSize: '15px',
                          fontWeight: '500',
                          cursor:
                            selectedPaymentMethod === 'management' &&
                            !managementReason.trim()
                              ? 'not-allowed'
                              : 'pointer',
                          minWidth: '120px',
                        }}
                      >
                        Confirm
                      </button>
                    </div>
                  </>
                )}
              </section>
            </Elements>
          )}
        </div>
      )}
    </div>
  );
};

export default Renewals;
